import React from 'react';
import classNames from 'classnames';
import './notificationBar.module.scss';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import { Warning } from '@material-ui/icons';

export type NotificationBarType = 'danger' | 'warning';

export const NotificationTitle = ({ children }: { children: React.ReactNode }) => (
  <div styleName="notification-title">{children}</div>
);
export const NotificationSubTitle = ({ children }: { children: React.ReactNode }) => (
  <div styleName="notification-sub-title">{children}</div>
);

type Props = {
  id?: string;
  type: NotificationBarType;
  buttonLabel?: string;
  onClick?: () => void;
  children: React.ReactNode;
};

export class NotificationBar extends React.Component<Props> {
  render() {
    const { id, type, buttonLabel, onClick, children } = this.props;
    return (
      <div styleName={classNames('notification-bar', type)} id={id}>
        <div styleName="notification-bar-inner">
          <div styleName="icon-wrapper">
            <Warning styleName="icon" />
          </div>
          <div styleName="body">
            <div styleName="message-wrapper">{children}</div>
            {buttonLabel && (
              <Button type="primary-inverted" size="s" styleName={classNames('button', type)} onClick={onClick}>
                {buttonLabel}
              </Button>
            )}
          </div>
        </div>
      </div>
    );
  }
}
